import { FunctionComponent } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { Box } from '@black-bear-energy/rucksack'
import { ChecklistCategoryAPIResponse } from '@black-bear-energy/black-bear-energy-common'
import { useSiteRFPDocumentExchangeDetails } from '../../api/hooks/useSiteRFPDocumentExchangeDetails'
import { ChecklistCategoryButton } from './ChecklistCategoryButton'

export const SelectChecklistPage: FunctionComponent = () => {
  const { customerRFPId, siteRFPId } = useParams<{
    customerRFPId: string
    siteRFPId: string
  }>()
  const history = useHistory()

  const handleCategoryClick = (category: ChecklistCategoryAPIResponse) => {
    const categoryPath = category.toLowerCase()
    history.push(
      `/document-exchange/projects/${customerRFPId}/sites/${siteRFPId}/${categoryPath}`
    )
  }

  const { data: siteRFPDocumentExchangeDetails } =
    useSiteRFPDocumentExchangeDetails(Number(siteRFPId))
  const availableCategories =
    siteRFPDocumentExchangeDetails?.availableChecklistCategories ?? []

  return (
    <Box sx={{ display: 'flex', gap: 5 }}>
      {availableCategories.includes(ChecklistCategoryAPIResponse.Contracts) && (
        <ChecklistCategoryButton
          category={ChecklistCategoryAPIResponse.Contracts}
          onClick={() =>
            handleCategoryClick(ChecklistCategoryAPIResponse.Contracts)
          }
        />
      )}
      {availableCategories.includes(
        ChecklistCategoryAPIResponse.Construction
      ) && (
        <ChecklistCategoryButton
          category={ChecklistCategoryAPIResponse.Construction}
          onClick={() =>
            handleCategoryClick(ChecklistCategoryAPIResponse.Construction)
          }
        />
      )}
    </Box>
  )
}
